module.exports = __webpack_public_path__ + "static/media/1010663.d02e3da8.jpg";